<template>
  <div class="c-footer">
    <div class="footer-content">
      <div class="up-part">
        <div class="up-left">
          <div class="about">
            <span @click="goUrl('/aboutUs','')">关于八戒小贷</span>
          </div>
          <div style="display: flex; flex-direction: row;margin-top: 10px;">
              <div>
                  <div style="cursor: pointer;">
                    <span @click="goUrl('/aboutUs','Introduce')">公司介绍</span>
                  </div>
                  <div style="margin-top: 20px;cursor: pointer;">
                    <span @click="goUrl('/aboutUs','Cultrue')">企业文化</span>
                  </div>
              </div>
              <div style="margin-left: 40px;">
                <div style="cursor: pointer;">
                  <span @click="goUrl('/aboutUs','Course')">发展历程</span>
                </div>
                <div style="margin-top: 20px;cursor: pointer;">
                  <span @click="showPl()">信息披露</span>
                </div>
              </div>
          </div>
        </div>
        <div class="up-middle">
          <div class="about">客服热线</div>
          <div class="phone" style="margin-top: 30px;">023-88392602</div>
        </div>
        <div class="up-right">
          <div class="about">商务合作</div>
          <div style="margin-top: 40px;">bjjrkf@bajiegroup.com</div>
        </div>
      </div>
      <div class="down-part">
        <p>
          <a href="https://beian.miit.gov.cn/state/outPortal/loginPortal.action" target="_blank">Copyright 2019-2020 jr-zbj.com 版权所有 | 渝ICP备2025066797号-1</a>
        </p>
      </div>
    </div>
    <discloseDialog ref="discloseDialog"/>
  </div>
</template>

<script>
import discloseDialog from './discloseDialog.vue'
export default {
  name: "c-footer",
  components:{
    discloseDialog
  },
  data() {
    return {};
  },
  computed: {
    isOpen: function () {
      return this.$store.getters.getSidebarState;
    },
  },
  methods: {
    showPl(){
      this.$refs.discloseDialog.show()
    },
    goUrl(url, id) {
      let path = this.$route.path;
      this.$router.push({
        path: url,
        query: { scroll: id },
      });
      if (path === "/aboutUs") {
        document.querySelector("#" + id).scrollIntoView(true);
      }
    },
  },
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
@import "..\..\global\css\mixin\mixin.less";
.c-footer {
  width: 100%;
  height: 208px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: url("./img/footer-bg.png") no-repeat center;
  .footer-content {
    width: 1200px;
    margin: 0 auto;
    color: #666;
    padding-bottom: 20px;
    .up-part{
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-around;
      padding: 35px 0;
    }
    .about {
      line-height: 40px;
      height: 40px;
      color: #ffffff;
      font-size: 18px;
    }
    .phone {
      line-height: 40px;
      height: 40px;
      color: #ffffff;
      font-size: 20px;
    }
    .agent {
      color: #fff;
    }
    .down-part {
      text-align: center;
      a {
        color: #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?ce5d401c